// extracted by mini-css-extract-plugin
export default {"not_data":"NoData_not_data__vRge9","animate-rotate":"NoData_animate-rotate__2zroI"};